import { Dialog, DialogPanel } from "@headlessui/react";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { GOOGLE_PLAY_LINK } from "@/utils/constatns";

import Button from "../buttons/Button";

const OpenAppStoreModal = ({ onClose, open }: { onClose: () => void; open: boolean }) => {
  const isAndroid = /(android)/i.test(navigator.userAgent);
  const { t } = useTranslation();

  const openLink = () => {
    //@ts-ignore
    window.location = isAndroid ? GOOGLE_PLAY_LINK : "https://splay-qr.splay.uz/redirect/";
    onClose();
  };

  useEffect(() => {
    if (open) {
      sessionStorage.setItem("shouldShowStoreModal", "0");
    }
  }, [open]);

  return (
    <Dialog open={open} transition onClose={onClose} className={"headless-dialog !items-end"}>
      <DialogPanel className={"bottom-0 bg-surface shadow-[0px_0px_2.875rem_#ff570830]"}>
        <img src="images/store-banner.png" className="h-auto w-full" alt="" />
        <div className="flex flex-col gap-7 p-4">
          <div className="flex items-center gap-2">
            <img src="images/small-logo.png" className="mr-[0.5rem] h-[1.9rem] w-[1.9rem]" />
            <span>{t("app")}</span>
            <Button onClick={openLink} className="ml-auto h-[2rem] w-[6.25rem] py-2" size="small">
              {t("go")}
            </Button>
          </div>
          <div className="flex items-center gap-2">
            <img
              className="mr-[0.5rem] h-[1.9rem] w-[1.9rem]"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Google_Chrome_icon_%28February_2022%29.svg/1024px-Google_Chrome_icon_%28February_2022%29.svg.png"
            />
            <span>Chrome</span>
            <Button onClick={onClose} className="ml-auto h-[2rem] w-[6.25rem] bg-surface-container py-2" size="small">
              {t("stay")}
            </Button>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
};

export default OpenAppStoreModal;
